import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { RentalsRes } from 'features/rentals/types/rentals.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchRentals = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: rentals,
		isPending: loadingRentals,
		isSuccess: isRentalsSuccess
	} = useQuery<RentalsRes>({
		queryKey: queryKeys.rentals.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.rentals(query)),
		enabled: !!auth.accessToken
	})

	return {
		rentals,
		loadingRentals,
		isRentalsSuccess
	}
}
